import { render, staticRenderFns } from "./FormContactAccount.vue?vue&type=template&id=2afa6966&"
import script from "./FormContactAccount.vue?vue&type=script&lang=ts&"
export * from "./FormContactAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afa6966')) {
      api.createRecord('2afa6966', component.options)
    } else {
      api.reload('2afa6966', component.options)
    }
    module.hot.accept("./FormContactAccount.vue?vue&type=template&id=2afa6966&", function () {
      api.rerender('2afa6966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactAccount.vue"
export default component.exports